import { render } from "./GraphOne.vue?vue&type=template&id=3a206558&scoped=true"
import script from "./GraphOne.vue?vue&type=script&lang=js"
export * from "./GraphOne.vue?vue&type=script&lang=js"

import "./GraphOne.vue?vue&type=style&index=0&id=3a206558&lang=scss&scoped=true"

import exportComponent from "F:\\homework\\tokenza\\tokenza\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a206558"]])

export default __exports__